import { render, staticRenderFns } from "./agrial-rich-text-editor.vue?vue&type=template&id=602b4a9b&scoped=true"
import script from "./agrial-rich-text-editor.vue?vue&type=script&lang=js"
export * from "./agrial-rich-text-editor.vue?vue&type=script&lang=js"
import style0 from "./agrial-rich-text-editor.vue?vue&type=style&index=0&id=602b4a9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602b4a9b",
  null
  
)

export default component.exports